import { getAuthenticatedInstance } from './helpers/axios.helpers';

const authenticatedInstance = getAuthenticatedInstance();

export async function getOrganizations(): Promise<any> {
  return authenticatedInstance.get('/organizations');
}
